import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

const ACHPaymentLimitModal = ({ open, setOpen }) => {
  return (
    <Modal size='small' open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)}>
      <Modal.Header> Amount Exceed</Modal.Header>
      <Modal.Content>
        Cannot use ACH for payments over $6K USD. Only credit card option is available for this amount.
      </Modal.Content>
      <Modal.Actions>
        <Button basic content='Close' onClick={() => setOpen(false)} />
      </Modal.Actions>
    </Modal>
  );
};

export default ACHPaymentLimitModal;
